import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const getMemberTransactions = () => {
    const transactions = getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberTransactions);
    return transactions ? transactions.results : [];
};
